import { Component, Input, Output, EventEmitter } from "@angular/core";



@Component({
  selector: 'activity-view',
  styleUrls: ['./activity-view.component.css'],
  templateUrl: './activity-view.component.html'
})
export class ActivityViewComponent {

  constructor() {
    //logged values at this point are values before evaulation is complete
  }

  @Input()
  isComplete: boolean = false;

  @Input()
  showMarkComplete: boolean = true;

  @Input()
  section: string = "";

  @Input()
  module: string = "";

  @Input()
  title: string = "";

  @Input()
  activityId: string = "";

  @Input()
  canMoveNext: boolean = true;

  @Input()
  canMovePrev: boolean = false;

  @Output()
  complete: EventEmitter<{ activityId: string, moveNext:boolean }> = new EventEmitter<{ activityId: string, moveNext:boolean }>();

  @Output()
  next: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  prev: EventEmitter<string> = new EventEmitter<string>();

  completeClick() {
    this.complete.emit({activityId: this.activityId, moveNext: true});
  }
  nextClick() {
    this.next.emit(this.activityId);
  } 
  prevClick() {
    this.prev.emit(this.activityId);
  }

}
